import axiosInstance from '../../../config/axiosInstance';
const CustomerService = {
    async GetAllCustomers(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetAllCustomers?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetAllNewCustomers(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "",SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllNewCustomers?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetCustomerCount(redirectCallback, searchQuery, EmailingName = "",SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetCustomerCount?ClientID=${ClientID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetCustomerByID(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetCustomerByID?ID=${ID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteCustomer(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/DeleteCustomer?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetCustomerCost(redirectCallback, ClientCompanyID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetCustomerCost?ClientCompanyID=${ClientCompanyID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async IsAccountNoExist(AccountNo, ClientCompanyID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/IsAccountNoExist?AccountNo=${AccountNo}&ClientCompanyID=${ClientCompanyID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async IsCompanyExist(CompanyName, PostCode, ClientCompanyID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/IsCompanyExist?CompanyName=${CompanyName}&PostCode=${PostCode}&ClientCompanyID=${ClientCompanyID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async ConvertCustomerDetail(CustomerID, OpportunityID, quotationID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/ConvertCustomerDetail?CustomerID=${CustomerID}&OpportunityID=${OpportunityID}&ClientID=${ClientID}&QuotationID=${quotationID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async LockCustomer(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Customer/LockCustomer?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockCustomer(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Customer/UnLockCustomer?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SyncCustomerToFinancial(ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/SyncCustomerToFinancialApp?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&action=Customer`);
            if (response.data) {
                if (response.data.authUrl) {
                    // Open QuickBooks auth popup
                    const authPopup = window.open(
                        response.data.authUrl,
                        'QuickbookAuth',
                        'width=600,height=700,top=100,left=100'
                    );

                    if (!authPopup) {
                        throw new Error('Popup blocked. Please enable popups.');
                    }

                    // Polling to wait for user to close the popup
                    const interval = setInterval(() => {
                        if (authPopup.closed) {
                            clearInterval(interval);
                            console.log('Popup closed. Retrying QuickBooks customer creation...');
                            // Retry once popup is closed
                            //  this.QuickbookAddCustomer(ClientCompanyID);
                        }
                    }, 500);
                    return;
                } else {
                    // Success case
                    return response.data;
                }
            }

        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetSearchLog(ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetSearchLog?ClientID=${ClientID}&UserID=${UserID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetEmailing(ModuleID, emailName) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetEmailing?ClientID=${ClientID}&UserID=${UserID}&ModuleID=${ModuleID}&emailName=${emailName}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async AddEmailing(ID, ModuleID, emailingName) {
        try {
            const idString = ID.join(',');
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/AddEmailing?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}&ModuleID=${ModuleID}&EmailingName=${emailingName}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DeleteEmailing(ID) {
        try {
            const idString = ID.join(',');
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/DeleteEmailing?ID=${idString}&ClientID=${ClientID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetEmailingByName(ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetEmailingByName?ClientID=${ClientID}&UserID=${UserID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteEmailingByID(ID) {
        try {

            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/DeleteEmailingByID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async DeleteEmailingByName(ModuleID, EmailingName) {
        try {

            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/DeleteEmailingByName?ClientID=${ClientID}&UserID=${UserID}&ModuleID=${ModuleID}&EmailingName=${EmailingName}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
     async GetCustomerOpportunites() {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetCustomerOpportunites?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllCustomersForQuotation(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetAllCustomersForQuotation?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllCustomerForStockCategory(CategoryID,redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetAllCustomerForStockCategory?ClientID=${ClientID}&CategoryID=${CategoryID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    
};

export default CustomerService;